/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Geofence action to be performed.
 */
export var GeofenceOperationType;
(function (GeofenceOperationType) {
    GeofenceOperationType["ADD"] = "add";
    GeofenceOperationType["DELETE"] = "delete";
    GeofenceOperationType["EDIT"] = "edit";
})(GeofenceOperationType || (GeofenceOperationType = {}));
